import React from "react";
import PropTypes from "prop-types";
import Popup from "reactjs-popup";
import { Button } from "@opendate-app/setlist";

const CONFIRM_POPUP_STYLE = {
  border: "none",
  borderRadius: 8,
  padding: 0,
  width: "min(440px, calc(100vw - 40px))",
  textAlign: "left",
};

// Shared destructive-action confirmation modal (reactjs-popup). Used by the
// schedule row actions and the passes/packs row actions in this bundle.
const ConfirmDialog = ({ open, title, body, confirmLabel, confirmDisabled, onConfirm, onClose }) => (
  <Popup open={open} modal className="popup-modal" contentStyle={CONFIRM_POPUP_STYLE} onClose={onClose} closeOnDocumentClick>
    <div className="popup-modal-container">
      <div className="row m-0 series-confirm-header">
        <div className="col series-confirm-header-col">
          <p className="mb-0 series-confirm-title"><strong>{title}</strong></p>
        </div>
        <div className="col-xs-auto d-flex align-items-center">
          <a
            href="#"
            className="text-muted series-confirm-close"
            onClick={(e) => { e.preventDefault(); onClose(); }}
          >
            <i className="fa fa-times" />
          </a>
        </div>
      </div>
      <div className="row m-0">
        <div className="col-12 series-confirm-body">
          <div className="text-muted mb-4">{body}</div>
          <div className="d-flex justify-content-end series-confirm-actions">
            <Button variant="secondary" onClick={onClose}>
              Keep
            </Button>
            <Button variant="destructive" data-testid="series-confirm-btn" disabled={confirmDisabled} onClick={() => { onConfirm(); onClose(); }}>
              {confirmLabel}
            </Button>
          </div>
        </div>
      </div>
    </div>
  </Popup>
);

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
  body: PropTypes.node.isRequired,
  confirmLabel: PropTypes.string.isRequired,
  confirmDisabled: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ConfirmDialog;
